import { CSSObject } from '@emotion/react'

export const shareQrCode = (): {
  [key: string]: Record<string, CSSObject | string | number>
} => ({
  qrWrapper: {
    display: 'flex',
    flexDirection: 'column', // Stack QR code and button vertically
    alignItems: 'center', // Center horizontally
    justifyContent: 'center', // Center vertically
    width: '100%',
    // height: "100%", // Make sure there
  },
  qrContainer: {
    margin: '0 auto',
    backgroundColor: '#fff',
    padding: 10,
  },
  actionButton: {
    cursor: 'pointer',
    border: '1px solid #595959',
    borderRadius: 24,
    padding: 4,
    justifyContent: 'center',
    margin: '10px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 180,
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  buttonIcon: {
    marginRight: 10,
  },
  buttonText: {
    fontSize: 14,
    color: '#595959',
    fontFamily: 'Gilroy-Regular',
    padding: '0px 4px',
    margin: 0,
  },
})
